'use es6';

export const CLEAR_SENDER = 'CLEAR_SENDER';